import { DatePipe, NgClass } from '@angular/common';
import {
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  NgbDate,
  NgbDateAdapter,
  NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { BlurOnClickDirective } from '../../directives';
import { AirportPickerComponent } from '../airport-picker/airport-picker.component';
import { FlightDatepickerComponent } from '../flight-datepicker/flight-datepicker.component';
import { DotLoaderComponent } from '../dot-loader/dot-loader.component';

import { Airport } from '../../models/app';
import { SearchFlightSelectionType } from '../../enums';

import { SearchService } from '../../services/app';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  standalone: true,
  imports: [
    NgClass,
    ReactiveFormsModule,
    NgbDatepickerModule,
    ReactiveFormsModule,
    AirportPickerComponent,
    FlightDatepickerComponent,
    DotLoaderComponent,
    DatePipe,
    BlurOnClickDirective,
  ],
})
export class SearchComponent implements OnInit, OnDestroy {
  private _subscriptions$: Subscription[] = [];
  private _ngbDateAdapter = inject(NgbDateAdapter<Date>);

  readonly showInDrawer = input(false);
  readonly showInSidebar = input(false);
  readonly SelectionType = SearchFlightSelectionType;
  readonly selectionType = signal(SearchFlightSelectionType.from);
  readonly searchService = inject(SearchService);

  readonly f = this.searchService.f;
  dataForm = this.searchService.dataForm;

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this._subscriptions$.forEach((s) => s?.unsubscribe());
  }

  onOpenAirportPicker(
    selectionType: SearchFlightSelectionType,
    picker: AirportPickerComponent,
  ) {
    this.selectionType.set(selectionType);
    picker.open();
  }

  onOpenFlightDatePicker(
    selectionType: SearchFlightSelectionType,
    picker: FlightDatepickerComponent,
  ) {
    this.selectionType.set(selectionType);
    const initDate =
      selectionType === SearchFlightSelectionType.from
        ? this.dataForm.value.date
        : this.dataForm.value.returnDate;
    picker.open(initDate && this._ngbDateAdapter.fromModel(initDate));
  }

  onSelectAirport(airport: Airport) {
    this.searchService.updateAirport(this.selectionType(), airport);
  }

  onSelectDate(value: NgbDate) {
    this.searchService.updateDate(this.selectionType(), value);
  }

  onSwapAirport() {
    this.searchService.swapAirport();
  }

  onSearch(): void {
    this.searchService.navigateToSelectFlight();
  }
}
